export var FORMATIONS_BY_TEAM_SIZE = {
    5: ["1-2-1", "2-1-1", "1-1-2", "2-0-2"],
    6: ["2-2-1", "2-1-2", "1-2-2", "1-3-1", "3-2", "2-3"],
    7: ["2-3-1", "3-2-1", "2-1-2-1", "2-2-2", "1-4-1", "2-1-3", "4-1-1"],
    11: [
        "4-3-3",
        "4-4-2",
        "4-2-3-1",
        "3-5-2",
        "3-4-3",
        "4-5-1",
        "4-1-4-1",
        "4-3-1-2",
        "4-4-1-1",
        "4-2-2-2",
        "4-3-2-1",
        "4-1-3-2",
        "4-1-2-3",
        "4-2-4",
        "4-2-1-3",
        "3-4-2-1",
        "3-4-1-2",
        "3-1-4-2",
        "3-5-1-1",
        "3-3-1-3",
        "3-3-3-1",
        "3-2-4-1",
        "2-3-4-1",
        "5-3-2",
        "5-4-1",
        "5-2-3",
        "5-2-2-1",
    ],
};
export var TEAM_SIZES = [5, 6, 7, 11];
export var FORMATION_DRAG_TYPE = "formation-player";
